import { useEffect, useMemo, useState } from 'react';

export const useScriptTableData = (scriptData, rowsPerPage) => {
    const [currentPage, setCurrentPage] = useState(1);

    // Prepare table data
    const tableData = useMemo(() => (
        scriptData
            ? scriptData.drugs.map((drug) => ({ ...drug }))
            : []
    ), [scriptData]);

    // Derived pagination values
    const totalPages = Math.max(1, Math.ceil((tableData?.length || 0) / rowsPerPage));

    const pagedData = useMemo(() => {
        const start = (currentPage - 1) * rowsPerPage;
        return tableData.slice(start, start + rowsPerPage);
    }, [tableData, currentPage, rowsPerPage]);

    // Reset to first page if data source changes
    useEffect(() => { setCurrentPage(1); }, [scriptData]);

    return {
        tableData,
        currentPage,
        setCurrentPage,
        pagedData,
        totalPages,
    };
};
